module.exports = __webpack_public_path__ + "static/media/logo_fassai.87613509.webp";